import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './WhoIAm.css';

function WhoIAm() {
  return (
    <div className="whoiam-section">
      <Helmet>
        <title>About Me - Szakacs Visuals</title>
        <meta name="description" content="Learn about Tamas Szakacs, a professional photographer and videographer based in Bristol, UK. Specializing in weddings, portraits, and commercial photography." />
        <meta property="og:title" content="About Me - Szakacs Visuals" />
        <meta property="og:description" content="Learn about Tamas Szakacs, a professional photographer and videographer based in Bristol, UK. Specializing in weddings, portraits, and commercial photography." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/whoiam" />
        <meta property="og:image" content="https://szakacsvisuals.co.uk/og-cover.jpg" />
        <meta property="og:image:alt" content="Szakacs Visuals Photography" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/whoiam" />
      </Helmet>
      <div className="whoiam-content">
        <img className="whoiam-image" src="/images/me.jpg" alt="Who I Am" />
        <div className="whoiam-text">
          <h1>Who I Am</h1>
          <p>Hi, I'm Tamas, a passionate photographer based in Bristol, dedicated to capturing the beauty of life's special moments. With years of experience, I strive to create timeless memories for my clients.</p>
          <p>My journey into photography wasn't exactly a straight line. A while back, I packed my bags and headed to Asia for six months. What started as a travel adventure quickly turned into something more – I found myself documenting every moment, from bustling markets to serene mountain views. Before I knew it, I was hooked on capturing the world through a lens.</p>
          <p>Now, I get to turn that passion into a career, working with amazing people to tell their stories through photos and videos. Whether it's a stunning wedding, a cozy family shoot, or a brand needing something a little different, I'm all about creating work that feels authentic and alive.</p>
          <p>When I'm not behind the camera, you'll probably find me chasing sunsets, planning my next adventure, or figuring out how to make the perfect cup of coffee.</p>
          <p>So, that's me in a nutshell. If you're looking for a photographer who's not just about the posed shots but also the in-between, real moments, let's chat.</p>
          <Link to="/contact" className="contact-button">Contact Me</Link>
        </div>
      </div>
    </div>
  );
}

export default WhoIAm; 